/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_ReleasesInputs */

const en_wc_footer_releases = /** @type {(inputs: Wc_Footer_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All releases`)
};

/**
* | output |
* | --- |
* | "All releases" |
*
* @param {Wc_Footer_ReleasesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_releases = /** @type {((inputs?: Wc_Footer_ReleasesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_ReleasesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_releases(inputs)
});
export { wc_footer_releases as "wc.footer.releases" }